import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {makeStyles} from '@material-ui/core/styles'
import {
    Box,
    CssBaseline,
    Drawer,
    Button,
    IconButton,
    InputBase,
    List,
    ListItem,
    ListItemText,
    Typography,
    Fade,
    Slide,
} from '@material-ui/core'

import {connect} from 'react-redux'
import Close from '@material-ui/icons/Close'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import {dataActions} from '../../../actions'
import noSearchResults from '../../../images/cs-no-search-results.svg'

const drawerWidth = '23rem'

// using hook API
const useStyles = makeStyles(theme => ({
    root: {
        display: '-webkit-flexbox',
    },
    searchBox: {
        display: '-webkit-flexbox',
        flexWrap: 'wrap',
        alignItems: 'center',
        border: '1px solid',
        borderColor: theme.palette.grey.medium,
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        margin: '8px 25px 0 32px',
        paddingRight: '5px',
    },
    searchInput: {
        margin: theme.spacing(1),
        flex: 1,
        width: '80%',
        [theme.breakpoints.down('sm')]: {
            width: '75%',
        },
    },
    iconButtonOpen: {
        height: '3rem',
        width: '2.0rem',
        minWidth: '1.5rem',
        position: 'fixed',
        top: '90px',
        left: '-4px',
        backgroundColor: theme.palette.green.medium,
        '&:hover': {
            backgroundColor: theme.palette.green.light,
        },
    },
    iconButton: {
        padding: 10,
        backgroundColor: '#F4F8F8',
        '&:hover': {
            opacity: '0.8',
            backgroundColor: '#F4F8F8',
        },
        transition: theme.transitions.create(['transform'], {
            duration: theme.transitions.duration.shortest,
        }),
    },
    clearButton: {
        padding: 10,
        color: theme.palette.grey.medium,
    },
    drawer: {
        width: drawerWidth,
    },
    drawerPaper: {
        width: drawerWidth,
        position: 'relative',
        height: '93vh',
        border: 'none',
        backgroundColor: '#F4F8F8',
        overflowY: 'auto',
        // [theme.breakpoints.down('sm')]: {
        //    width: '80%',
        // },
    },
    selected: {
        borderLeft: '5px solid #02AB77',
    },
    drawerOpen: {
        transform: 'rotate(180deg)',
    },
}))

const EventDrawer = props => {
    const classes = useStyles()
    const {
        token,
        occurrence,
        loadingOccurrence,
        setOccurrence,
        open,
        handleDrawerOpen,
        handleDrawerClose,
        eventlist,
    } = props

    const {deptId, eventId, occurId} = occurrence
    const activeoccurrence = deptId + eventId + occurId

    const [searchTerm, setSearchTerm] = useState('')
    const [searchResults, setSearchResults] = useState(eventlist)

    const handleChange = e => {
        setSearchTerm(e.target.value)
    }

    const handleClearSearch = () => {
        setSearchTerm('')
    }

    useEffect(() => {
        const results = eventlist.filter(event =>
            event.occurTitle.toLowerCase().includes(searchTerm.toLowerCase())
        )
        setSearchResults(results)
    }, [eventlist, searchTerm])

    return (
        <>
            <CssBaseline />
            <div className={classes.root}>
                {!open && (
                    <Fade in={true} mountOnEnter unmountOnExit timeout={400}>
                        <Button
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => handleDrawerOpen()}
                            edge="start"
                            className={classes.iconButtonOpen}
                        >
                            <ChevronRightIcon
                                style={{color: '#FFFFFF', fontSize: '2.5rem'}}
                            />
                        </Button>
                    </Fade>
                )}
                <Slide direction="right" in={open} mountOnEnter unmountOnExit>
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={open}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <Box
                            display="-webkit-flexbox"
                            flexDirection="column"
                            style={{padding: '7% 0 0 0'}}
                            width="23rem"
                        >
                            <Box
                                display="flex"
                                alignItems="center"
                                flexDirection="row"
                                justifyContent="space-between"
                                style={{paddingLeft: '32px'}}
                            >
                                <Typography
                                    variant="h5"
                                    style={{color: '#000000'}}
                                >
                                    Events & Services
                                </Typography>
                                <IconButton
                                    className={clsx(
                                        classes.iconButton,
                                        !open && classes.drawerOpen
                                    )}
                                    onClick={() => handleDrawerClose()}
                                >
                                    <ChevronLeftIcon
                                        style={{fontSize: '2.5rem'}}
                                    />
                                </IconButton>
                            </Box>
                            <Box className={classes.searchBox}>
                                <InputBase
                                    className={classes.searchInput}
                                    placeholder="Search"
                                    inputProps={{
                                        'aria-label': 'search events',
                                    }}
                                    value={searchTerm}
                                    onChange={handleChange}
                                />
                                {searchTerm && (
                                    <IconButton
                                        className={classes.clearButton}
                                        onClick={() => handleClearSearch()}
                                    >
                                        {' '}
                                        <Close />{' '}
                                    </IconButton>
                                )}
                            </Box>

                            {Array.isArray(searchResults) &&
                            !searchResults.length ? (
                                <Box
                                    align="center"
                                    style={{margin: '60px 0 0 15px'}}
                                >
                                    <img
                                        src={noSearchResults}
                                        alt="no search result"
                                    />
                                    <Typography variant="h5">
                                        No Matches Found
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        style={{marginTop: '5px'}}
                                    >
                                        {eventlist.length ? (
                                            <>
                                                We couldn’t find anything for
                                                &quot;<b>{searchTerm}</b>
                                                &quot;, try another term or
                                                check with your Unit
                                                Administrator to make sure
                                                you’ve been added as a Swiper to
                                                the event/service you’re
                                                seeking.
                                            </>
                                        ) : (
                                            <>
                                                We couldn’t find any events
                                                assigned to you. Check with your
                                                Unit Administrator to make sure
                                                you’ve been added as a Swiper to
                                                the event/service you’re
                                                seeking.
                                            </>
                                        )}
                                    </Typography>
                                </Box>
                            ) : (
                                <List>
                                    {searchResults.map(occurrence => (
                                        <ListItem
                                            button
                                            className={
                                                activeoccurrence ===
                                                occurrence.deptId +
                                                    occurrence.eventId +
                                                    occurrence.occurId
                                                    ? classes.selected
                                                    : ''
                                            }
                                            key={
                                                occurrence.deptId +
                                                occurrence.eventId +
                                                occurrence.occurId
                                            }
                                            disabled={loadingOccurrence}
                                            selected={
                                                activeoccurrence ===
                                                occurrence.deptId +
                                                    occurrence.eventId +
                                                    occurrence.occurId
                                            }
                                            onClick={() =>
                                                setOccurrence(
                                                    activeoccurrence ===
                                                        occurrence.deptId +
                                                            occurrence.eventId +
                                                            occurrence.occurId
                                                        ? {}
                                                        : {token, occurrence}
                                                )
                                            }
                                        >
                                            <ListItemText
                                                primary={occurrence.occurTitle}
                                                primaryTypographyProps={{
                                                    variant: 'body1',
                                                    style: {
                                                        fontWeight:
                                                            activeoccurrence ===
                                                            occurrence.deptId +
                                                                occurrence.eventId +
                                                                occurrence.occurId
                                                                ? '700'
                                                                : '400',
                                                        margin: '0 15px 0 20px',
                                                    },
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            )}
                        </Box>
                    </Drawer>
                </Slide>
            </div>
        </>
    )
}

EventDrawer.propTypes = {
    token: PropTypes.string.isRequired,
    occurrence: PropTypes.object,
    loadingOccurrence: PropTypes.bool,
    setOccurrence: PropTypes.func.isRequired,
    open: PropTypes.bool,
    handleDrawerOpen: PropTypes.func.isRequired,
    handleDrawerClose: PropTypes.func.isRequired,
    eventlist: PropTypes.array,
    searchTerm: PropTypes.string,
}

function mapStateToProps(state) {
    return {
        occurrence: state.occurrencedata.occurrence,
        loadingOccurrence: state.occurrencedata.loadingOccurrence,
        token: state.authentication.token,
    }
}

const mapDispatchToProps = {
    setOccurrence: payload => dataActions.occurSetRequest(payload),
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDrawer)
